export const calculateEndDate = (startDate, startLag, duration, durationHours) => {
    startLag = startLag || 0;
    var endDate = new Date(startDate);
    var wholeDaysFromHours = Math.floor((durationHours + startLag) / ep.options.general.HoursPerDay);
    endDate.setDate(endDate.getDate() + duration + wholeDaysFromHours - ((durationHours + startLag) % ep.options.general.HoursPerDay > 0 ? 0 : 1));
    return endDate;
};

export const calculateStartDate = (endDate, endLag, duration, durationHours) => {
    endLag = endLag || 0;
    var startDate = new Date(endDate);
    startDate.setDate(endDate.getDate() - duration + (endLag === 0 ? 1 : 0) + ((endLag - (durationHours % ep.options.general.HoursPerDay)) >= 0 ? 0 : -1));
    return startDate;
};

export const calculateEndLag = (startLag, durationHours) => {
    startLag = startLag || 0;
    return (startLag + durationHours) % ep.options.general.HoursPerDay;
};

export const calculateStartLag = (endLag, durationHours) => {
    endLag = endLag % ep.options.general.HoursPerDay;

    var startDateLag = (endLag - durationHours) % ep.options.general.HoursPerDay;

    startDateLag = startDateLag < 0 ? (startDateLag + ep.options.general.HoursPerDay) : startDateLag;

    return startDateLag;
};

export const endLagOrFullDay = (endLag, hoursPerDay = ep.options.general.HoursPerDay) => {
    return endLag || hoursPerDay;
};
